import {directive} from 'vue-clickaway'
import loadingDirective from './components/Loading/directive'
/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', directive)
    Vue.use(loadingDirective);
  }
}

export default GlobalDirectives
